module.exports = __webpack_public_path__ + "static/pic02.561da81f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pic02.jpg
// module id = 485
// module chunks = 114276838955818